import {makeAutoObservable} from 'mobx';

import {ONE_SECOND_MS} from '@/shared/consts/time';

import {autoupdateCurrentTime} from './autoupdateCurrentTime';

class AppStore {
  private _currentTime = Date.now();

  constructor() {
    makeAutoObservable(this);
  }

  get currentTime() {
    return this._currentTime;
  }

  setCurrentTime(currentTime: number) {
    this._currentTime = currentTime;
  }
}

const store = new AppStore();

autoupdateCurrentTime(store, 10 * ONE_SECOND_MS);

export default store;
